export const useNotificationListener = () => {
  // notifications do not work on web.
};
